import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

const FooterLoggedOut = ({
    applicationVersion,
    currentYear,
    technicalHelpDeskHours,
    technicalHelpDeskNumber,
}) => {
    const footerLeft = {
        __html: `Call the MyBSWHealth technical help desk ${technicalHelpDeskHours} at <a href=${'tel:' + technicalHelpDeskNumber} className="phone-link">${technicalHelpDeskNumber}</a>.`,
    };

    const footerRight = {
        __html: `<div class="copyright">© ${currentYear} All Rights Reserved</div><div class='mychart-copyright'>Version: ${applicationVersion}</div>`,
    };

    return <div className="container-fluid footer-container footer-loggedout">
        <div className="row">
            <div className="col-12 maxWidth-content">
                <div className="row">
                    <div className="col-12 col-md-8 footer__links">
                        <p
                            className="footer-left"
                            dangerouslySetInnerHTML={footerLeft}
                        ></p>
                    </div>
                    <div
                        className="col-12 col-md-4 footer__copyright"
                        dangerouslySetInnerHTML={footerRight}
                    ></div>
                </div>
            </div>
        </div>
    </div>;
};

const mapStateToProps = state => {
    return {
        applicationVersion: state.session.serverData
            ? state.session.serverData.applicationVersion
            : '1.0.0.0', // we'll default with rendering for mybswhealth
        currentYear:
            state.session.serverData && state.session.serverData.currentYear
                ? state.session.serverData.currentYear
                : '2022',
        technicalHelpDeskHours: state.session.serverData
            ? state.session.serverData.technicalHelpDeskHours
            : '',
        technicalHelpDeskNumber: state.session.serverData
            ? state.session.serverData.technicalHelpDeskNumber
            : '',
    };
};

export default connect(mapStateToProps)(FooterLoggedOut);
